  <ng-container *ngIf="(unreadCount$ | async) as unreadCount">
    <span
      *ngIf="unreadCount !== 0"
      [ngClass]="{ 'op-ian-bell--indicator': true, 'op-ian-bell--indicator_max': unreadCount > bellDisplayLimit }"
      data-test-selector="op-ian-notifications-count"
      [innerHTML]="unreadCountText$ | async"
    ></span>
  </ng-container>
